// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ManagePropertyRolesModal_modalBody_zC4kk"};